import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PortalReferralCreditNotAppliedReason } from '@app/services/api/api.types';
import { referralCreditNotAppliedCopy } from '@app/services/referral-program/referral-credit-messages.util';

@Component({
  selector: 'referral-credit-not-applied-banner',
  templateUrl: './referral-credit-not-applied-banner.component.html',
  styleUrls: ['./referral-credit-not-applied-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralCreditNotAppliedBannerComponent {
  @Input() reason?: PortalReferralCreditNotAppliedReason | null;

  get copy() {
    return referralCreditNotAppliedCopy(this.reason);
  }
}
